var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_66_38",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_66_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.083 28.333C20.4723 28.333 20.7987 28.2013 21.062 27.938C21.326 27.674 21.458 27.3473 21.458 26.958V21.5H27C27.3613 21.5 27.674 21.368 27.938 21.104C28.2013 20.84 28.333 20.5137 28.333 20.125C28.333 19.7083 28.2013 19.368 27.938 19.104C27.674 18.84 27.3473 18.708 26.958 18.708H21.458V13C21.458 12.6387 21.326 12.3263 21.062 12.063C20.7987 11.799 20.4723 11.667 20.083 11.667C19.6943 11.667 19.368 11.799 19.104 12.063C18.84 12.3263 18.708 12.6527 18.708 13.042V18.708H13C12.6387 18.708 12.326 18.847 12.062 19.125C11.7987 19.403 11.667 19.7363 11.667 20.125C11.667 20.5137 11.7987 20.84 12.062 21.104C12.326 21.368 12.6527 21.5 13.042 21.5H18.708V27C18.708 27.3613 18.84 27.674 19.104 27.938C19.368 28.2013 19.6943 28.333 20.083 28.333ZM20 36.667C17.6667 36.667 15.486 36.2363 13.458 35.375C11.4307 34.5137 9.66701 33.333 8.16701 31.833C6.66701 30.333 5.48634 28.5693 4.62501 26.542C3.76367 24.514 3.33301 22.3333 3.33301 20C3.33301 17.6667 3.76367 15.486 4.62501 13.458C5.48634 11.4307 6.66701 9.66699 8.16701 8.16699C9.66701 6.66699 11.4307 5.48633 13.458 4.62499C15.486 3.76366 17.6667 3.33299 20 3.33299C22.3333 3.33299 24.514 3.76366 26.542 4.62499C28.5693 5.48633 30.333 6.66699 31.833 8.16699C33.333 9.66699 34.5137 11.4307 35.375 13.458C36.2363 15.486 36.667 17.6667 36.667 20C36.667 22.3333 36.2363 24.514 35.375 26.542C34.5137 28.5693 33.333 30.333 31.833 31.833C30.333 33.333 28.5693 34.5137 26.542 35.375C24.514 36.2363 22.3333 36.667 20 36.667ZM20 33.875C23.8333 33.875 27.104 32.5207 29.812 29.812C32.5207 27.104 33.875 23.8333 33.875 20C33.875 16.1667 32.5207 12.896 29.812 10.188C27.104 7.47933 23.8333 6.12499 20 6.12499C16.1667 6.12499 12.896 7.47933 10.188 10.188C7.47934 12.896 6.12501 16.1667 6.12501 20C6.12501 23.8333 7.47934 27.104 10.188 29.812C12.896 32.5207 16.1667 33.875 20 33.875Z",
    fill: "#6EEB83"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.9a1dbf9ab97e2c7378e6962656021393.svg";
export { ForwardRef as ReactComponent };